import React from 'react';

const ShareContext = React.createContext({
  color: {

  },
}); 
// 第一个参数是默认值

export default ShareContext;
